import * as companySettingsActions from '@Actions/companySettings';
import {
	CompanySettings,
	error as notificationError,
} from '@innovyze/stylovyze';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	getCurrentCompanySettings,
	updateCurrentCompanySettings,
} from '@Services/companySettings';
import { CompanySettingsParams } from '@Types';
import { AxiosResponse } from 'axios';
import { put, retry, takeLatest } from 'redux-saga/effects';

function* getCurrentCompanySettingsSaga(
	action: PayloadAction<CompanySettingsParams>,
) {
	const { ...params } = action.payload;
	try {
		const response: AxiosResponse<CompanySettings> = yield retry(
			5,
			1500,
			getCurrentCompanySettings,
			params,
		);

		if (response.data) {
			yield put(
				companySettingsActions.getCurrentCompanySettingsResolved(
					response.data,
				),
			);
		} else {
			throw new Error('OperationStatus != SUCCESS');
		}
	} catch (e) {
		console.error(e);
		yield put(companySettingsActions.getCurrentCompanySettingsRejected());
	}
}

function* updateCurrentCompanySettingsSaga(
	action: PayloadAction<Partial<CompanySettings>>,
) {
	try {
		const response: AxiosResponse<Partial<CompanySettings>> = yield retry(
			5,
			1500,
			updateCurrentCompanySettings,
			action.payload,
		);

		if (response.data) {
			yield put(
				companySettingsActions.updateCurrentCompanySettingsResolved(
					action.payload,
				),
			);
		} else {
			yield put(
				companySettingsActions.updateCurrentCompanySettingsRejected(
					action.payload,
				),
			);
			yield put(notificationError('Error updating company settings'));
			throw new Error('OperationStatus != SUCCESS');
		}
	} catch (e) {
		yield put(notificationError('Error updating company settings'));
		yield put(
			companySettingsActions.updateCurrentCompanySettingsRejected(
				action.payload,
			),
		);
	}
}

function* watchGetCurrentCompanySettings() {
	yield takeLatest(
		companySettingsActions.getCurrentCompanySettings,
		getCurrentCompanySettingsSaga,
	);
}

function* watchUpdateCurrentCompanySettings() {
	yield takeLatest(
		companySettingsActions.updateCurrentCompanySettings,
		updateCurrentCompanySettingsSaga,
	);
}

export default [
	watchGetCurrentCompanySettings(),
	watchUpdateCurrentCompanySettings(),
];
